import { formatValue } from 'shared/lib/sendGAEvents/formatValue';
import type { IInitialEvent } from 'shared/lib/sendGAEvents/interface';

import { isProduction } from '../isProduction';

export const sendEventToGA = (event: IInitialEvent, currentWindow = window) => {
  const data = {
    event: event.event,
    eventCategory: event.eventCategory || 'Кредиты',
    eventAction: formatValue(event.eventAction) || '',
    eventLabel: formatValue(event.eventLabel),
    eventValue: event.eventValue,
  };

  if (isProduction()) {
    if (typeof currentWindow.sravniDataLayer === 'undefined') {
      currentWindow.sravniDataLayer = [];
    }

    if (event.eventCallback && currentWindow.sravniDataLayer.push === Array.prototype.push) {
      event.eventCallback();
    }

    currentWindow.sravniDataLayer.push(data);
  } else {
    // eslint-disable-next-line no-console
    console.groupCollapsed(`Analytics Event: ${formatValue(event.eventAction)}`);
    // eslint-disable-next-line no-console
    console.table(data);
    // eslint-disable-next-line no-console
    console.groupEnd();
  }
};
